import * as React from "react";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { ImageStatus } from "../Resouces/Contents";
import { SharedStore } from "../../../Shared/Stores/Variable";
import * as classNames from "classNames";

interface IUploadFormProps extends React.Props<UploadForm> {
    getImageBlobData: (blobData: any) => void;
    onSelectAnotherChage: (val: boolean) => void;
    imageBlobData?: any;
    imageStatus?: ImageStatus;
    cssWrapper?: string;
    maxSize?: { width: number; height: number };
    fileSizeAlertMessage?: string;
}

interface IUploadFormState {
    imageBlobData?: any;
    imageStatus?: ImageStatus;
    fileIsBeingDraggedOver?: boolean;
    maxSize?: { width: number; height: number };
}

export class UploadForm extends FormComponent<IUploadFormProps, IUploadFormState> {
    private inputRef: any;

    constructor(props: IUploadFormProps) {
        super(props);
        const _imgBlobData = this.props.imageBlobData || null;
        const _imgStatus = this.props.imageStatus;
        this.state = {
            imageBlobData: _imgBlobData,
            imageStatus: _imgStatus,
            fileIsBeingDraggedOver: false,
            maxSize: props.maxSize || { width: 500, height: 200 },
        };
        this.subscribeToStore(SharedStore, () => this.onConfigurationStoreChange());
    }

    private onConfigurationStoreChange() {
        const _data = SharedStore.getData();
        if (_data && _data.Logo) {
            this.setState({ imageBlobData: _data.Logo, imageStatus: ImageStatus.ImageChosen });
        }
    }

    private inputChange() {
        const file = this.inputRef.files[0];
        const ext = file.name.substr(file.name.lastIndexOf(".") + 1);
        if (["png", "jpg", "jpeg", "svg"].indexOf(ext.toLowerCase()) > -1) {
            const image = new Image();
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({ imageBlobData: reader.result, imageStatus: ImageStatus.ImageChosen });
                this.props.getImageBlobData(reader.result);
                if (reader !== null && typeof reader.result == "string") {
                    image.src = reader.result;
                }
            };
            if (file) {
                reader.readAsDataURL(file);
            }
            image.onload = () => {
                const maxSize = this.state.maxSize;
                if (image.width > maxSize.width || image.height > maxSize.height) {
                    this.props.getImageBlobData(null);
                    this.setState({ imageBlobData: reader.result, imageStatus: ImageStatus.ImageSizeNotMatch });
                }
            };
        } else {
            this.props.getImageBlobData(null);
            this.setState({ imageStatus: ImageStatus.IsNotAnImage });
        }
    }

    public render() {
        let showHtml = null;
        switch (this.state.imageStatus) {
            case ImageStatus.None:
                showHtml = this.renderUploadForm();
                break;
            case ImageStatus.IsNotAnImage:
                showHtml = this.renderFileTypeAlert();
                break;
            case ImageStatus.ImageChosen:
                showHtml = this.renderImagePreview();
                break;
            case ImageStatus.ImageSizeNotMatch:
                showHtml = this.renderFileSizeAlert();
                break;
        }

        return (
            <div className="slide-panel">
                <div key={this.state.imageStatus}>{showHtml}</div>
            </div>
        );
    }

    private renderUploadForm() {
        return (
            <div
                key="upload"
                className={classNames(
                    "file-dropzone",
                    { "highlight-dragover": this.state.fileIsBeingDraggedOver },
                    this.props.cssWrapper
                )}
                aria-live="polite"
            >
                <label htmlFor="file-dropzone-input">
                    <span className="sr-only">Drag and drop file here or select an image from your computer</span>
                </label>
                <input
                    id="file-dropzone-input"
                    type="file"
                    ref={(ref) => (this.inputRef = ref)}
                    onChange={() => this.inputChange()}
                    onDragOver={() => {
                        this.setState({ fileIsBeingDraggedOver: true });
                    }}
                    onDragLeave={() => {
                        this.setState({ fileIsBeingDraggedOver: false });
                    }}
                    onDrop={() => {
                        this.setState({ fileIsBeingDraggedOver: false });
                    }}
                />
                <div className="icon" aria-hidden={true}></div>
                <div className="cta" aria-hidden={true}>
                    Drag and drop file here
                    <br />— or —
                </div>
                <div className="hyperlink" aria-hidden={true}>
                    Select an image from your computer
                </div>
            </div>
        );
    }

    private renderFileTypeAlert() {
        return (
            <div key="alert">
                <p role="alert">The selected file is not an image or the image is corrupted.</p>
                <button
                    className="hyperlink"
                    onClick={() => {
                        this.setState({ imageStatus: ImageStatus.None });
                    }}
                >
                    Try again
                </button>
            </div>
        );
    }

    private renderFileSizeAlert() {
        const { width, height } = this.state.maxSize;
        return (
            <div key="alert">
                <p role="alert" className="text-negative">
                    {this.props.fileSizeAlertMessage ?? `The selected file should small than ${width} x ${height}.`}
                </p>
                <button
                    className="hyperlink"
                    onClick={() => {
                        this.setState({ imageStatus: ImageStatus.None });
                    }}
                >
                    Try again
                </button>
            </div>
        );
    }

    private renderImagePreview() {
        const file = this.inputRef ? this.inputRef.files[0] : null;
        const imageURI = this.state.imageBlobData;
        return (
            <div key="preview" className="image-preview-on-site mb-50">
                <div className="dot1" aria-hidden={true}></div>
                <div className="dot2" aria-hidden={true}></div>
                <div className="dot3" aria-hidden={true}></div>
                <div className="viewport">
                    <div className="skel2" aria-hidden={true}></div>
                    <div className="skel3" aria-hidden={true}></div>
                    <div className="head row row-right mt-20">
                        <div
                            className="thumb"
                            key={file ? file.name : "thumb"}
                            style={{ backgroundImage: "url(" + imageURI + ")" }}
                        ></div>
                        <div className="skel1" aria-hidden={true}></div>
                    </div>
                </div>
                <div className="clear">
                    <button
                        className="hyperlink text-size-14"
                        onClick={() => {
                            this.setState({ imageStatus: ImageStatus.None }, () =>
                                this.props.onSelectAnotherChage(true)
                            );
                        }}
                    >
                        Select another image
                    </button>
                </div>
            </div>
        );
    }
}
